import React, { Component } from 'react';
import AssessmentHistory from './AssessmentHistory';
import AssessmentTreatment from './AssessmentTreatment';
import { formatData, AssessmentInnerContainer, valueThenSubHeaderSection, valueThenSubTextDivs } from './examUtils';
import './Exam.css'

class ChiropodyExam extends Component {
	state = {}

	render() {

		const formattedExam = (formatData(this.props.data.exam))

		const Exam = formattedExam || {};
		const { Assessments, Objective, Plan, 'Procedure Type': ProcedureType, Subjective, 
			'Treatment Type': TreatmentType, 'Visit Type': VisitType, 'Visit Comments': VisitComments } = Exam || {};

		const { Dermatological, 'Initial Comments': InitialComments, Interspaces, MSK, Nails, 
			Neurological, 'Skin Lesions': SkinLesions, Vascular } = Objective || {};

		const orderedVascularKeys = ['Dorsalis Pedis', 'Posterior Tibialis', 'Capillary Filling Time', 'Varicosities', 
			'Temperature Gradient', 'Skin Temperature', 'Edema', 'Hair Growth', 'Dependent Rubor / Pallor / Cyanosis', 'Comments']
		const orderedSkinLesionsKeys = ['Hyperkeratoses', 'Verruca', 'Preulcerative Area', 'Ulcerations', 'Other']
		const orderedMSKKeys = ['Hammer Toes', 'Mallet Toes', 'Claw Toes', 'HAV / Bunion', 'STJ Range of Motion', 
			'Ankle Range of Motion', 'MTPJ Range of Motion', 'Crepitus / Effusion', 'Amputation', 'Foot Type', 'Comments']
		const orderedPlanKeys = ['Educated On', 'Recommendations', 'Treatment', 'Will Return in Weeks', 'Will Return in Weeks Other', 'Care Providers', 'External Referral']

		if (Object.keys(formattedExam).filter(key => key !== 'Updated At').length === 0) {
			return (
				<div className="Exam">
					{/* HISTORY */}
					<AssessmentHistory data={this.props.data.history} />

					<div className="Exam__details-container">
						<div className="Exam__details-container-header">
							<h2>Chiropody Exam</h2>
						</div>
						<div className="Exam__details">
							<div className="Exam__details-not-found">No Exam Data Found</div>
						</div>
					</div>
				
					{/* TREATMENT */}
					<AssessmentTreatment data={this.props.data.treatment} />
				</div>
			)
		}

		return (
			<div className="Exam">
				{/* HISTORY */}
				<AssessmentHistory data={this.props.data.history} />

				{/* CHIROPODY EXAM */}
				<div className="Exam__details-container">
					<div className="Exam__details-container-header">
						<h2>Chiropody Exam</h2>
					</div>
					{VisitType && <AssessmentInnerContainer header="Visit Type">
						{valueThenSubTextDivs({value: VisitType})}
					</AssessmentInnerContainer>}
					{VisitComments && <AssessmentInnerContainer header="Visit Comments">
						{valueThenSubTextDivs({value: VisitComments})}
					</AssessmentInnerContainer>}
					<AssessmentInnerContainer header="Treatment Details">
						{valueThenSubHeaderSection('Treatment Type', TreatmentType)}
						{valueThenSubHeaderSection('Procedure Type', ProcedureType)}
						{valueThenSubHeaderSection('Subjective', Subjective)}
					</AssessmentInnerContainer>
					{VisitType && <AssessmentInnerContainer header="Initial Comments">
						{valueThenSubTextDivs({value: InitialComments})}
					</AssessmentInnerContainer>}
					{Vascular && <AssessmentInnerContainer header="Vascular">
						{orderedVascularKeys.slice(0, 2).map((key, i) => (
							Vascular[key] && (
								<React.Fragment key={i}>
									<h3 className="Exam__details-sub-header">{key}:</h3>
									{valueThenSubTextDivs({value: Vascular[key], units: '/4'})}
								</React.Fragment>
							)
						))}
						{valueThenSubHeaderSection('Capillary Filling Time', Vascular['Capillary Filling Time'], 'sec')}
						{orderedVascularKeys.slice(2, 6).map((key, i) => (
							Vascular[key] && (
								<React.Fragment key={i}>
									<h3 className="Exam__details-sub-header">{key}:</h3>
									{valueThenSubTextDivs({value: Vascular[key]})}
								</React.Fragment>
							)
						))}
						{Vascular.Edema && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Edema:</h3>
								{Vascular.Edema.Right && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Right</div>
										{valueThenSubTextDivs({value: Vascular.Edema.Right.Yn})}
										{valueThenSubTextDivs({value: Vascular.Edema.Right.Location, label: 'Location'})}
									</div>
								)}
								{Vascular.Edema.Left && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Left</div>
										{valueThenSubTextDivs({value: Vascular.Edema.Left.Yn})}
										{valueThenSubTextDivs({value: Vascular.Edema.Left.Location, label: 'Location'})}
									</div>
								)}
							</React.Fragment>
						)}
						{orderedVascularKeys.slice(7).map((key, i) => (
							Vascular[key] && (
								<React.Fragment key={i}>
									<h3 className="Exam__details-sub-header">{key}:</h3>
									{valueThenSubTextDivs({value: Vascular[key]})}
								</React.Fragment>
							)
						))}
					</AssessmentInnerContainer>}
					{Dermatological && <AssessmentInnerContainer header="Dermatological">
						{Object.keys(Dermatological).map((key, i) => (
							<React.Fragment key={i}>
								{valueThenSubHeaderSection(key, Dermatological[key])}
							</React.Fragment>
						))}
					</AssessmentInnerContainer>}
					{SkinLesions && <AssessmentInnerContainer header="Skin Lesions">
						{orderedSkinLesionsKeys.map((key, i) => (
							SkinLesions[key] && (
								<React.Fragment key={i}>
									{valueThenSubHeaderSection(key, SkinLesions[key])}
								</React.Fragment>
							)
						))}
					</AssessmentInnerContainer>}
					{Interspaces && <AssessmentInnerContainer header="Interspaces">
						{Object.keys(Interspaces).map((key, i) => (
							<React.Fragment key={i}>
								{valueThenSubHeaderSection(key, Interspaces[key])}
							</React.Fragment>
						))}
					</AssessmentInnerContainer>}
					{Nails && <AssessmentInnerContainer header="Nails">
						{Object.keys(Nails).map((key, i) => (
							<React.Fragment key={i}>
								{valueThenSubHeaderSection(key, Nails[key])}
							</React.Fragment>
						))}
					</AssessmentInnerContainer>}
					{Neurological && <AssessmentInnerContainer header="Neurological">
						{Neurological.DTR && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">DTR:</h3>
								{Neurological.DTR.Right && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Right</div>
										{valueThenSubTextDivs({value: Neurological.DTR.Right.Ankle, label: 'Ankle'})}
										{valueThenSubTextDivs({value: Neurological.DTR.Right.Patellar, label: 'Patellar'})}
										{Neurological.DTR.Right['Is Deferred'] && <div className="Exam__details-sub-text">Is Deferred</div>}
									</div>
								)}
								{Neurological.DTR.Left && (
									<div className="Exam__details-sub-text-section">
										<div className="Exam__details-sub-text">Left</div>
										{valueThenSubTextDivs({value: Neurological.DTR.Left.Ankle, label: 'Ankle'})}
										{valueThenSubTextDivs({value: Neurological.DTR.Left.Patellar, label: 'Patellar'})}
										{Neurological.DTR.Left['Is Deferred'] && <div className="Exam__details-sub-text">Is Deferred</div>}
									</div>
								)}
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Ambulatory', Neurological.Ambulatory)}
						{valueThenSubHeaderSection('Babinksi Sign', Neurological['Babinski Sign'])}
						{Neurological.Monofilament && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Monofilament:</h3>
								{valueThenSubTextDivs({value: Neurological.Monofilament.Value, units: '/10'})}
								{valueThenSubTextDivs({value: Neurological.Monofilament.Status})}
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Comments', Neurological.Comments)}
					</AssessmentInnerContainer>}
					{MSK && <AssessmentInnerContainer header="MSK">
						{MSK['Hammer Toes'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Hammer Toes:</h3>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Hammer Toes'].Right, label: 'Right'})}
								</div>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Hammer Toes'].Left, label: 'Left'})}
								</div>
							</React.Fragment>
						)}
						{MSK['Mallet Toes'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Mallet Toes:</h3>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Mallet Toes'].Right, label: 'Right'})}
								</div>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Mallet Toes'].Left, label: 'Left'})}
								</div>
							</React.Fragment>
						)}
						{MSK['Claw Toes'] && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Claw Toes:</h3>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Claw Toes'].Right, label: 'Right'})}
								</div>
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs({value: MSK['Claw Toes'].Left, label: 'Left'})}
								</div>
							</React.Fragment>
						)}
						{orderedMSKKeys.slice(3).map((key, i) => (
							MSK[key] && (
								<React.Fragment key={i}>
									{valueThenSubHeaderSection(key, MSK[key])}
								</React.Fragment>
							)
						))}
					</AssessmentInnerContainer>}
					{Assessments && <AssessmentInnerContainer header="Assessments">
						{Assessments.map((assessment, i) => (
							<div key={i} className="Exam__details-sub-text-section">
								{valueThenSubTextDivs({value: assessment})}
							</div>
						))}
					</AssessmentInnerContainer>}
					{Plan && <AssessmentInnerContainer header="Plan">
						{orderedPlanKeys.map((key, i) => (
							Plan[key] && (
								<React.Fragment key={i}>
									{valueThenSubHeaderSection(key, Plan[key])}
								</React.Fragment>
							)
						))}
					</AssessmentInnerContainer>}
				</div>

				{/* TREATMENT */}
				<AssessmentTreatment data={this.props.data.treatment} />
			</div>
		);
	}
}
 
export default ChiropodyExam;


// WEBPACK FOOTER //
// ./src/views/Assessment/ChiropodyExam.js